import type { InAppAlert } from './inboxApi';

const SEVERITY_LABEL: Record<string, string> = { critical: 'Critical', warning: 'Warning', info: 'Info' };

/** Severity chip (Critical / Warning / Info); nothing when the rule has none. */
export function SeverityChip({ severity }: { severity?: InAppAlert['severity'] }) {
  if (!severity) return null;
  return <span className={`ia-chip ${severity}`}>{SEVERITY_LABEL[severity] ?? severity}</span>;
}

/** "ACK REQUIRED" until acknowledged, then "Acknowledged"; "Resolved" when it auto-resolved first. */
export function AckChip({ required, ackAt, resolvedAt }: { required: boolean; ackAt?: string | null; resolvedAt?: string | null }) {
  if (ackAt) return <span className="ia-chip done"><i className="ti ti-check" />Acknowledged</span>;
  if (resolvedAt) return <span className="ia-chip done" title="Auto-resolved: the condition cleared."><i className="ti ti-circle-check" />Resolved</span>;
  if (!required) return null;
  return <span className="ia-chip ack">ACK REQUIRED</span>;
}
